import React from "react";
import MapComponent from "./MapComponent";

function HomePage() {
  const position = [40.112652228645196, 9.51495748067807]; // Coordinata di Londra per esempio

  return (
    <div>
      <MapComponent position={position} />
    </div>
  );
}

export default HomePage;
